export function initPodcastIntroFinderAnalytics(root = document) {
  if (!root || root.__podcastIntroFinderAnalyticsInitialized) {
    return
  }

  root.__podcastIntroFinderAnalyticsInitialized = true
  const resultHeading = root.querySelector('[data-podcast-intro-result]')
  const validationError = root.querySelector('[data-podcast-intro-error]')
  if (resultHeading) {
    resultHeading.focus()
  } else if (validationError) {
    validationError.focus()
  }
  const sendFunnelEvent = (element, stage, sentKey) => {
    const endpoint = element?.dataset?.podcastIntroAnalyticsUrl
    if (!endpoint || element.dataset[sentKey] === 'true') {
      return
    }

    const csrfToken = root.querySelector('meta[name="csrf-token"]')?.content
    if (!csrfToken) {
      return
    }

    element.dataset[sentKey] = 'true'
    fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'X-CSRF-Token': csrfToken,
        Accept: 'application/json'
      },
      body: `funnel_stage=${encodeURIComponent(stage)}`
    }).catch(() => {
      element.dataset[sentKey] = 'false'
    })
  }

  root.addEventListener('play', (event) => {
    const audio = event.target
    sendFunnelEvent(audio, 'preview_started', 'podcastIntroAnalyticsSent')
  }, true)

  root.addEventListener('change', (event) => {
    const form = event.target?.closest?.('form[data-podcast-intro-questionnaire]')
    if (!form) {
      return
    }

    sendFunnelEvent(form, 'questionnaire_started', 'podcastIntroQuestionnaireStarted')
  }, true)
}
